<template>
    <VueFinalModal
        content-transition="fade-scale"
        content-class="h-full"
        :lock-scroll="false"
        :reserve-scroll-bar-gap="false">
        <div class="flex h-full w-screen cursor-pointer items-center justify-center overflow-hidden md:py-16" @click.self="() => closeProductModal()">
            <div class="relative m-auto size-full cursor-auto rounded-md bg-white md:h-auto md:min-h-0 md:max-w-2xl md:rounded lg:max-w-3xl">
                <div class="flex h-full flex-col md:h-auto">
                    <FormKit
                        v-slot="{ state: { valid } }"
                        type="form"
                        :actions="false"
                        :incomplete-message="false"
                        :classes="{
                            form: 'flex h-full flex-col md:h-auto'
                        }"
                        :on-submit-invalid="true"
                        :disabled="!!Object.keys(productForm().extraDetailsInfo).length"
                        @submit="addToCart()"
                    >
                        <ModalProductHeader v-bind="props" />
                        <ModalProductBody v-bind="props" />
                        <ModalProductFooter v-bind="props" :valid="valid" />
                    </FormKit>
                    <ModalCloseButton class="right-6 top-6 z-50 md:-right-2.5 md:-top-4" @click="closeProductModal()" />
                </div>
            </div>
        </div>
    </VueFinalModal>
</template>

<script setup lang="ts">
    import type { ProductOrderBuddy } from '~/types/orderbuddy-types'
    import cloneDeep from 'lodash.clonedeep'
    import { VueFinalModal } from 'vue-final-modal'
    import ModalCloseButton from '~/components/Modal/ModalCloseButton.vue'
    import ModalProductBody from '~/components/Modal/ModalProduct/ModalProductBody.vue'
    import ModalProductFooter from '~/components/Modal/ModalProduct/ModalProductFooter.vue'
    import ModalProductHeader from '~/components/Modal/ModalProduct/ModalProductHeader.vue'
    import { cart } from '~/store/cart'
    import { productForm } from '~/store/productForm'
    export type ModalProductProps = ProductOrderBuddy & {
        productKeyToReplace?: string | number
    }
    const props = defineProps<ModalProductProps>()
    const emit = defineEmits<{
        (e: 'close'): void
    }>()
    function addToCart () {
        if (props.productKeyToReplace) {
            cart().updateProduct({
                id: props.id,
                ...cloneDeep(productForm().currentProductWithSelectedExtras)
            }, props.productKeyToReplace)
        } else {
            cart().addProduct({
                id: props.id,
                ...cloneDeep(productForm().currentProductWithSelectedExtras)
            })
        }
        closeProductModal()
    }
    function closeProductModal () {
        productForm().setExtraDetailsInfo({})
        productForm().resetCurrentProductWithSelectedExtras()
        emit('close')
    }
</script>
